import React from "react";
import styled from "styled-components";

import { Contact as Person } from "types";
import "../../node_modules/flag-icons/css/flag-icons.min.css";

interface ContactProps {
  contact: Person;
  showYear: boolean;
  countPerYear: number;
  onAgeClick: (age: number) => void;
  onAgeGapClick: (ageGap: number) => void;
  onCountryClick: (code: string) => void;
  onSourceClick: (source: string) => void;
  onFirstNameClick: (first: string) => void;
  onLastNameClick: (last: string) => void;
}

const SELF_BIRTH_YEAR = 1977;

const MONTHS = {
  1: "JAN",
  2: "FEB",
  3: "MAR",
  4: "APR",
  5: "MAY",
  6: "JUN",
  7: "JUL",
  8: "AUG",
  9: "SEP",
  10: "OCT",
  11: "NOV",
  12: "DEC",
};

const Contact = ({
  contact,
  showYear,
  countPerYear,
  onAgeClick,
  onAgeGapClick,
  onCountryClick,
  onSourceClick,
  onFirstNameClick,
  onLastNameClick,
}: ContactProps) => {
  const {
    id,
    ethnicity,
    first,
    middle,
    last = "",
    age,
    source,
    year,
    month,
    facebook,
  } = contact;

  const ageGap = age - (year - SELF_BIRTH_YEAR);
  return (
    <TR key={id}>
      {showYear ? <Year>{year}</Year> : <TD />}
      <Month>{MONTHS[month]}</Month>
      <TD>
        <span
          className={`fi fi-${ethnicity}`}
          onClick={() => onCountryClick(ethnicity)}
        ></span>
      </TD>
      <Name>
        <Span onClick={() => onFirstNameClick(first)}>{first}</Span> {middle}{" "}
        <Span onClick={() => onLastNameClick(last)}>{last}</Span>
      </Name>
      <TD>
        <Pill>
          <LeftPill>{id}</LeftPill>
          <RightPill>{countPerYear}</RightPill>
        </Pill>
      </TD>
      <TD clickable>
        <Pill>
          <LeftPill onClick={() => onAgeClick(age)}>{age}</LeftPill>
          <RightPill onClick={() => onAgeGapClick(ageGap)}>{ageGap}</RightPill>
        </Pill>
      </TD>
      <TD clickable>
        <Source onClick={() => onSourceClick(source)}>{source}</Source>
      </TD>
      <TD clickable>
        <Center>
          {facebook ? (
            <a
              href={`https://facebook.com/${facebook}`}
              rel="noopener noreferrer"
              target="_blank"
            >
              <Facebook isActive>f</Facebook>
            </a>
          ) : (
            <Facebook>f</Facebook>
          )}
        </Center>
      </TD>
    </TR>
  );
};

const TR = styled.tr`
  margin-bottom: 0.2rem;
`;

const TD = styled.td`
  padding: 0 0.2rem;
  text-align: center;
  cursor: ${(props: { clickable?: boolean }) =>
    props.clickable ? "pointer" : ""};
`;

const Center = styled.div`
  display: flex;
  justify-content: center;
`;

const Country = styled.img`
  cursor: pointer;
  margin-left: 0.5rem;
`;

const Name = styled(TD)`
  margin-left: 0.8rem;
  line-height: 3.5rem;
  pointer-events: none;
  text-align: left;
`;

const Span = styled.span`
  cursor: pointer;
  pointer-events: all;
`;

const Pill = styled.div`
  display: flex;
`;

const LeftPill = styled.span`
  display: flex;
  background-color: #d8dade;
  border-radius: 20%;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  font-size: 0.8rem;
  padding: 0.4rem;
  min-width: 1rem;
  justify-content: space-around;
`;

const RightPill = styled(LeftPill)`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  background-color: #eaedef;
  border-radius: 20%;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
`;

const Year = styled(TD)`
  margin-right: 0.5rem;
  font-weight: bold;
  line-height: 2rem;
  width: 2.5rem;
`;

const Month = styled(TD)`
  margin-right: 0.5rem;
  color: grey;
  width: 1rem;
  font-size: 0.8rem;
  width: 2.5rem;
`;

const Source = styled.span`
  font-size: 0.6rem;
`;

const Facebook = styled.span`
  display: flex;
  justify-content: center;
  background-color: ${(props: { isActive?: boolean }) =>
    props.isActive ? "#3a5ea5" : "#eaedef"};
  color: #ffffff;
  pointer-events: ${(props: { isActive?: boolean }) =>
    props.isActive ? "auto" : "none"};
  border-radius: 20%;
  font-size: 0.8rem;
  padding: 0.4rem;
  width: 0.8rem;
`;

export default Contact;
